import subscriberMockJson from './mocks/json/subscriber-mock.json';
import subscriberLangLabels from './mocks/json/subscriber-lang-labels.json';

export type SubscriberLang = 'de' | 'en';

export type MockSubscriber = {
  id: number;
  mail: string;
  username: string;
  language: SubscriberLang;
};

export type Topic = {
  id: number;
  name: string;
  buzzwords: string[];
  color: string;
};

export const TOPIC_COLORS: string[] = [...subscriberMockJson.topicColors];

export const MOCK_SUBSCRIBERS: MockSubscriber[] = subscriberMockJson.subscribers as MockSubscriber[];

function numericKeyRecord<T>(obj: Record<string, T>): Record<number, T> {
  return Object.fromEntries(
    Object.entries(obj).map(([k, v]) => [Number(k), v])
  ) as Record<number, T>;
}

export const MOCK_SCHEDULES: Record<number, { hour: string; minute: string }> = numericKeyRecord(
  subscriberMockJson.schedules
);

export const MOCK_TOPICS: Record<number, Topic[]> = numericKeyRecord(
  subscriberMockJson.topicsBySubscriber as Record<string, Topic[]>
);

export const MOCK_ARTICLE_COUNTS: Record<string, number> = { ...subscriberMockJson.articleCounts };

export const MOCK_TEMPLATES = [...subscriberMockJson.templates] as {
  id: number;
  name: string;
  accentColor: string;
  isDefault: boolean;
}[];

const rawAssignments = subscriberMockJson.templateAssignments as Record<string, number | null>;

export const MOCK_TEMPLATE_ASSIGNMENTS: Record<number, number | null> = numericKeyRecord(rawAssignments);

export const LANG_LABELS = subscriberLangLabels as Record<SubscriberLang, { flag: string; label: string }>;
